import type { ViewStyle } from "react-native";
import type { ViewProps } from "tamagui";

import type { InputProps } from "@/ui/theme/tamagui.config";
import { OpacityToken, ZIndexToken } from "@/ui/theme/tokens";

// Extend ViewProps with React Native's elevation property
type ExtendedViewProps = {
  elevation?: ViewStyle["elevation"];
} & ViewProps;

const ShadowStyles = {
  // Android requires elevation for shadows
  elevation: 5,
  shadowColor: "black",
  shadowOpacity: OpacityToken.Shadow,
  shadowRadius: 8,
  // zIndex is set here so that the shadow is on "top" of any other components
  zIndex: ZIndexToken.Base,
} satisfies ExtendedViewProps;

const BorderlessInputShadowStyles = {
  shadowColor: ShadowStyles.shadowColor,
  shadowOffset: {
    height: 1,
    width: 0,
  },
  shadowOpacity: 0.06,
  shadowRadius: 4,
  zIndex: ShadowStyles.zIndex,
} satisfies InputProps;

const AnimationStyles: Record<string, ViewProps> = {
  // expected to be passed via enterStyles={fadeIn}
  fadeIn: {
    // fade from 0% opacity -> 100% opacity
    opacity: 0,
  },
  // expected to be passed via exitStyles={fadeOut}
  fadeOut: {
    // fade from current opacity -> 0% opacity
    opacity: 0,
  },
  menuFadeIn: {
    // fade from 0% opacity -> 100% opacity
    opacity: 0,
    // fade from 10 below current position -> current position
    y: 10,
  },
};

export { AnimationStyles, BorderlessInputShadowStyles, ShadowStyles };
